import React, {Component, Fragment} from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import RoutePaths from "utils/RoutePaths";
import ListImages from "./ListImages";
import CreateImage from "./CreateImage";
import ImageDetails from "./ImageDetails";

// Helper to get relative path from full path
const getRelativePath = (fullPath) => fullPath.replace(/^\/admin\/imageregistry\/?/, '') || '/';

class ImageRegistry extends Component {
    render() {
        return (
            <Fragment>
                <Routes>
                    <Route path={getRelativePath(RoutePaths.createImageRegistry)} element={<CreateImage />} />
                    <Route path={getRelativePath(RoutePaths.getImageRegistry) + "/:imageName"} element={<ImageDetails />} />
                    <Route path={getRelativePath(RoutePaths.listImageRegistry)} element={<ListImages />} />
                    <Route path={getRelativePath(RoutePaths.defaultImageRegistry)} element={<Navigate to={getRelativePath(RoutePaths.listImageRegistry)} replace />} />
                </Routes>
            </Fragment>
        );
    }
}

export default ImageRegistry;